import axios from 'axios';

import { Resolve } from './';
import config from './config';

import { IClientAccount, IClientAccountLean, IClientAccountPlanStats, IClientAccountStats } from '@/models/clientAccount';

interface IData<T> {
  results: T[];
  item_count: number;
  page_count: number;
  current: number;
  next: number;
  previous: number;
}

const url = process.env.VUE_APP_SERVER_PATH;

export const searchClientAccounts = (page = 1, pageSize = 20, search?: string) =>
  new Promise((resolve: Resolve<IData<IClientAccountLean>>, reject) => {
    let queryString = `page=${page}&page_size=${pageSize}`;
    if (search) {
      queryString += `&query=${encodeURIComponent(search)}`;
    }
    axios
      .get(`${url}/v2/client-accounts/search?${queryString}`, config())
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getClientAccounts = (page = 1, pageSize = 20, ordering = '-id', type?: string, id?: number) =>
  new Promise((resolve: Resolve<IData<IClientAccount>>, reject) => {
    let queryString = `page=${page}&page_size=${pageSize}&ordering=${ordering}`;
    if (type) {
      queryString += `&type=${type}`;
    }
    if (id !== undefined) {
      queryString += `&id=${id}`;
    }
    axios
      .get(`${url}/v2/client-accounts?${queryString}`, config())
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getClientAccountStats = () =>
  new Promise((resolve: Resolve<IClientAccountStats>, reject) => {
    axios
      .get(`${url}/v2/client-accounts/stats`, config())
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getClientAccountPlanStats = () =>
  new Promise((resolve: Resolve<IClientAccountPlanStats>, reject) => {
    axios
      .get(`${url}/v2/client-accounts/plan-stats`, config())
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });

export const createClientAccount = (
  payload: {
    client_name: string;
    client_email: string;
    billing_name?: string;
    billing_vat_number?: string;
    billing_address?: string;
    billing_city?: string;
    billing_postal_number?: string;
    billing_country_code?: string;
  }
) =>
  new Promise((resolve: Resolve<IClientAccount>, reject) => {
    axios
      .post(`${url}/v2/client-accounts`, payload, config())
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
